import { render, staticRenderFns } from "./Metals.vue?vue&type=template&id=81844706&scoped=true"
import script from "./Metals.vue?vue&type=script&lang=js"
export * from "./Metals.vue?vue&type=script&lang=js"
import style0 from "./Metals.vue?vue&type=style&index=0&id=81844706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81844706",
  null
  
)

export default component.exports